module.exports = __webpack_public_path__ + "img/gmfq_gb3452_1_1992.prt.9d46b3a4.jpg";